import styled from 'styled-components'
import { SORT_BY_OPTIONS, SEARCH_FILTER_TYPE } from '@/features/shared/constants/global'
import { DISPLAY_FORMAT } from '@/features/shared/constants/analytics'
import { SortByFilterSection } from '@/features/shop/components/ProductFilter/SortByFilterSection'
import { FilterPillContent } from '@/features/shop/components/ProductFilter/FilterOptions/FilterPillContent'
import { useGetSortByOptions } from '@/features/shop/components/ProductFilter/useGetSortByOptions'
import { VDivider } from '@/features/shared/components/Dividers'
import { FilterScrollWrapper } from '@/features/shop/components/ProductFilter/FilterScrollWrapper'
import { useTrackFilterUtilityClicked } from '@/features/shared/analytics/filters'
import { useFiltersContext } from '@/features/shop/components/ProductFilter/FiltersContext'
import { useValidSearchParams } from '@/features/shared/hooks/search'
import { SortAltIcon } from '@shipt/design-system-icons'
import { screenSizes } from '@shipt/design-system-themes'
import { Box } from '@shipt/design-system-layouts'
import { type SortOptions } from '@/features/shop/services/Search/types'

type Props = {
  index: number
  hideDivider?: boolean
  sortOptions?: SortOptions[]
  sortSelected?: string
  sortDefaultValue?: string | null
}

export const SortByOption = ({
  index,
  hideDivider,
  sortOptions,
  sortSelected,
  sortDefaultValue,
}: Props) => {
  const trackFilterUtilityClicked = useTrackFilterUtilityClicked()
  const { defaultOption } = useGetSortByOptions()
  const { sort = '' } = useValidSearchParams()
  const { facets } = useFiltersContext()
  const { SORT_BY } = SEARCH_FILTER_TYPE
  const selectedOption = SORT_BY_OPTIONS[sort]
  const selectedOptionName = sortOptions?.find((option) => option.value === sortSelected)?.name
  const pillName = selectedOptionName ?? selectedOption ?? defaultOption

  const handleOnClickFilter = () => {
    trackFilterUtilityClicked({
      list_index: index,
      utility_type: 'dropdown',
      filter_value: SEARCH_FILTER_TYPE.SORT_BY,
      filter_active: Boolean(selectedOption),
      display_format: DISPLAY_FORMAT.HORIZONTAL,
    })
  }
  const renderIcon = () => (
    <Box marginRight="sm">
      <SortAltIcon size="sm" />
    </Box>
  )
  return (
    <FilterScrollWrapper facet={SORT_BY} index={index} isDropdown>
      <FilterPillContent
        name={pillName}
        filterType={SORT_BY}
        renderImg={renderIcon}
        onClick={handleOnClickFilter}
      >
        <SortByFilterSection sortOptions={sortOptions} sortDefaultValue={sortDefaultValue} />
      </FilterPillContent>
      {facets.length > 0 && !hideDivider && <Divider />}
    </FilterScrollWrapper>
  )
}

const Divider = styled(VDivider)`
  margin-left: 0;
  height: 1.875rem;
  display: none;

  @media ${screenSizes.tablet} {
    display: inherit;
  }
`
